<template>
  <NuxtLink :to="purchaseLink" :target="show.type === TYPE_EXTERNAL ? '_blank' : '_top'">
    <article class="card">
      <picture>
        <img :src="show.realFlyerPath" alt="Plop!">
      </picture>
      <h4>
        <NuxtTime :datetime="show?.eventDate" weekday="long" :locale="language.locale.value"/>
        <strong>
          <NuxtTime :datetime="show?.eventDate" day="numeric" :locale="language.locale.value" :hour12="true"/>
        </strong>
        <NuxtTime :datetime="show?.eventDate" month="long" :locale="language.locale.value" :hour12="true"/>
      </h4>
      <h3>{{ show?.name }}</h3>
      <p><strong>{{show?.location?.name}}</strong>  {{show?.location?.city}}</p>
      <a :href="purchaseLink" class="bt btG">Comprar entradas <i class="fa fa-arrow-right"/></a>
    </article>
  </NuxtLink>
</template>
<script setup lang="ts">

import type {ShowPublicObject} from "~/api/generated";
import {computed} from "vue";

const language = useI18n()

interface Props {
  show: ShowPublicObject;
}

const props = defineProps<Props>()
const purchaseLink = computed(() => {
  if(props.show.type === TYPE_EXTERNAL) {
    return props.show.externalUrl ?? '';
  }
  return `/shows/${props.show.path}`
});

</script>
